@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (reiskostenZorgGezinslid.length > 0) {
      <div formArrayName="reiskostenZorgGezinslid">
        @for (item of reiskostenZorgGezinslid.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Aantal bezoeken' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="aantalBezoeken"
                                              id="aantalBezoeken"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Afstand retour in km' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="afstandRetour"
                                              id="afstandRetour"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Kosten OV' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="werkelijkeKostenOV"
                                              id="werkelijkeKostenOV"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRij(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      </div>
    }
  </form>


  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus"
                       type="link">Reiskosten bezoek ziek gezinslid
  </snelstart-ui-button>
}
